'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  transition: color ease 0.25s;\n  text-decoration: underline;\n  font-style: italic;\n  margin-top: 10px;\n  display: block;\n\n  &:hover {\n    color: ', ';\n  }\n\n  span {\n    display: block;\n\n    &:first-of-type {\n      margin-bottom: 5px;\n    }\n  }\n'], ['\n  color: ', ';\n  transition: color ease 0.25s;\n  text-decoration: underline;\n  font-style: italic;\n  margin-top: 10px;\n  display: block;\n\n  &:hover {\n    color: ', ';\n  }\n\n  span {\n    display: block;\n\n    &:first-of-type {\n      margin-bottom: 5px;\n    }\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LocationLink = _styledComponents2.default.a(_templateObject, _config.colors.red, _config.colors.darkRed);

LocationLink.displayName = 'LocationLink';

exports.default = LocationLink;